/* NODE PACKAGES */
import React from 'react';
import { AxiosRequestConfig } from 'axios';
/* TYPES */
import { APIRequester, APIRequesterGroup, APIRegistrar, APIRegistrarGroup, APIRegistrarGroupMembers} from 'api/types';
/* HOOKS */
import {useAxios} from 'hooks';

export type RegistrarStore =
  {
  requesters: APIRequester[],
  requesterGroups: APIRequesterGroup[],
  registrars: APIRegistrar[],
  registrarGroups: APIRegistrarGroup[],
  error: boolean,
  loading: boolean,
  refresh: () => void
  getRequesterGroup(rqID: number): APIRequesterGroup;
  };

function useRegistrarGroupMembersStore(): RegistrarStore
  {
  const [response, error, loading, callAxios] = useAxios({method: 'GET', url: "/api/registrar_group_member_query_all"});
  const [requesters, setRequesters] = React.useState<APIRequester[]>([]);
  const [requesterGroups, setRequesterGroups] = React.useState<APIRequesterGroup[]>([]);
  const [registrars, setRegistrars] = React.useState<APIRegistrar[]>([]);
  const [registrarGroups, setRegistrarGroups] = React.useState<APIRegistrarGroup[]>([]);

  React.useEffect(() =>
    {
    if (response)
      {
      setRequesters(response.registrar_group_members.requesters.sort((a:APIRequester, b:APIRequester) => a.name.localeCompare(b.name)));
      setRequesterGroups(response.registrar_group_members.requester_groups.sort((a:APIRequesterGroup, b:APIRequesterGroup) => a.name.localeCompare(b.name)));
      setRegistrars(response.registrar_group_members.requesters.sort((a:APIRegistrar, b:APIRegistrar) => a.name.localeCompare(b.name)));
      setRegistrarGroups(response.registrar_group_members.registrar_groups.sort((a:APIRegistrarGroup, b:APIRegistrarGroup) => a.description.localeCompare(b.description)));
      }
    }, [response]);

  const refresh = () => callAxios();

  function getRequesterGroup (rqID: number)
    {
    return requesterGroups.filter((rqG:APIRequesterGroup) => rqG.id === rqID)[0] ?? {};
    }

  return {requesters, requesterGroups, registrars, registrarGroups, error, loading, refresh, getRequesterGroup} as RegistrarStore;
  }

export default useRegistrarGroupMembersStore;
